import Vue from 'vue'
import Router from 'vue-router'
import ActivityLogin from '@/views/ActivityLogin'
import LessonSelect from '@/views/LessonSelect'
import StoryPractice from '@/views/StoryPractice'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ActivityHome',
      component: ActivityLogin
    },
    {
      path: '/a/:activityId',
      name: 'ActivityLogin',
      component: ActivityLogin
    },
    {
      path: '/a/:activityId/lessons',
      name: 'LessonSelect',
      component: LessonSelect
    },
    {
      path: '/a/:activityId/lessons/:lessonIndex',
      name: 'StoryPractice',
      component: StoryPractice
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js